import React, { useContext, useEffect, useRef, useState } from "react";
import config from "../constants/config.js";
import { Avatar } from "primereact/avatar";
import { useDispatch, useSelector } from "react-redux";
import {
    getMyProfileAction,
    updateMyProfileAction,
    getMyRole
} from "../redux/Slices/userSlice";
import {
    setActiveOrg,
    setActiveOrgPlan
} from "../redux/Slices/organizationSlice";
import { useNavigate } from "react-router-dom";
import { Menu } from "primereact/menu";
import { PrimeReactContext } from "primereact/api";
import { Badge } from "primereact/badge";
import MainModel from "../components/Models";
import { CustomInput } from "../components/Inputs";
import { showFormErrors } from "../utils/commonFunctions";
import { logoutAction } from "../redux/Slices/authSlice";
import OrganizationForm from "../views/organization/OrganizationForm";
import { InputText } from "primereact/inputtext";
import Notifications from "../components/Notifications";

import { Button } from "primereact/button";
import { setSubscribedPlan } from "../redux/Slices/planSlice";

export default function Topbar({ activeRoute, setMobileMenu }) {
    const profileMenu = useRef(null);
    const notificatinRef = useRef(null);
    const orgDetails = useSelector(state => state.org.data);
    const userRole = useSelector((state) => state?.user?.userRole) || {};
    const activeOrg = useSelector(state => state.org.active);
    const user = useSelector((state) => state?.user?.data);
    const [isLightTheme, setIsLightTheme] = useState(false);
    const [isSetupProfile, setIsSetupProfile] = useState(false);
    const [selectedOption, setSelectedOption] = useState(activeOrg);
    const [isAddOrg, setIsAddOrg] = useState(false);
    const [showOrgSwitcher, setShowOrgSwitcher] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [data, setData] = useState({
        first_name: "",
        last_name: "",
    });
    const { changeTheme } = useContext(PrimeReactContext);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const activeOrgDetails = () => {
        if (orgDetails.length) {
            dispatch(setActiveOrg(orgDetails[0]))
            dispatch(getMyRole(orgDetails[0].id))
        } else {
            navigate('/')
        }
    };

    const handleOrgMenuClick = async ({ org }) => {
        
        setSelectedOption({ name: org?.name, id: org?.id });
        const oneOrg=orgDetails.find((orgD)=>orgD.id===org.id);
        dispatch(setActiveOrg(oneOrg));
        dispatch(setActiveOrgPlan(oneOrg?.Subscriptions[0]?.Plan));
        dispatch(setSubscribedPlan(oneOrg?.Subscriptions[0]));

        setShowOrgSwitcher(false);
        setSearchTerm("");
    };

    const filteredOrgs = Array.isArray(orgDetails)
        ? orgDetails.filter(org =>
            org.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

    useEffect(() => {
        if (!activeOrg || (typeof activeOrg === 'object' && Object.keys(activeOrg).length === 0)) {
            activeOrgDetails();
        } else {
            dispatch(getMyRole(activeOrg?.id))
            setSelectedOption(activeOrg)
        }
    }, [dispatch, activeOrg]);

    const profileMenuItems = [
        {
            label: "Documentation",
            icon: "pi pi-book",
            command: () => window.open(`https://docs.${config.domain}`, "_blank"),
        },
        {
            label: "Status Page",
            icon: "pi pi-chart-line",
            command: () => window.open(`https://status.${config.domain}`, "_blank"),
        },
        {
            label: "Support",
            icon: "pi pi-question-circle",
            command: () => window.open(`mailto:support@${config.domain}`),
        },
        {
            separator: true
        },
        {
            label: "Logout",
            icon: "pi pi-sign-out",
            command: () => dispatch(logoutAction({ navigate })),
        },
    ];

    const updateProfile = () => {
        if (showFormErrors(data, setData)) {
            let payload = {
                ...data,
                username: data?.first_name + " " + data?.last_name,
            };
            dispatch(
                updateMyProfileAction({
                    data: payload,
                    next: () => {
                        setIsSetupProfile(false);
                        dispatch(getMyProfileAction({ navigate }));
                    },
                })
            );
        }
    };

    // Notifications are now handled by the Notifications component

    useEffect(() => {
        changeTheme(
            isLightTheme ? "theme-light.css" : "theme-dark.css",
            isLightTheme ? "theme-dark.css" : "theme-light.css",
            "theme_link",
            () => null
        );
    }, [isLightTheme, changeTheme]);

    useEffect(() => {
        if (user && (user.first_name === null || user.username === null)) {
            setIsSetupProfile(true);
        } else {
            setIsSetupProfile(false);
        }
    }, [user]);

    return (
        <div className="sticky bg-surface-a top-0 flex justify-content-between align-items-center z-1 px-3 shadow-1">
            <OrganizationForm
                isAddOrg={isAddOrg}
                setIsAddOrg={setIsAddOrg}
                dispatch={dispatch}
            />
            <MainModel
                visible={isSetupProfile}
                setVisible={setIsSetupProfile}
                title="Welcome ...?"
                subTitle="ooops! can you please update your name?"
                onSave={updateProfile}
            >
                <CustomInput
                    value={data.first_name}
                    onChange={({ name, value }) => setData({ ...data, [name]: value })}
                    label="First Name"
                    name="first_name"
                    extraClass="border-round bg-gray-100"
                    data={data}
                />
                <CustomInput
                    value={data.last_name}
                    onChange={({ name, value }) => setData({ ...data, [name]: value })}
                    label="Last Name"
                    name="last_name"
                    extraClass="border-round bg-gray-100"
                    data={data}
                />
            </MainModel>

            <MainModel
                visible={showOrgSwitcher}
                setVisible={setShowOrgSwitcher}
                title={
                    <div className="flex align-items-center justify-content-between w-full">
                        <span>Switch Organization</span>
                        <Badge value={filteredOrgs.length} severity="info" />
                    </div>
                }
                hideFooter={true}
                style={{ width: '450px' }}
            >
                <div className="mb-3">
                    <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" style={{ left: '0.75rem' }} />
                        <InputText
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search organizations..."
                            className="w-full"
                            style={{
                                paddingLeft: '2.5rem',
                                borderRadius: '6px',
                                height: '36px'
                            }}
                        />
                    </span>
                </div>
                <div
                    className="flex flex-column"
                    style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        borderRadius: '6px',
                        background: 'var(--surface-ground)'
                    }}
                >
                    {filteredOrgs.map((org) => (
                        <div
                            key={org.id}
                            className={`py-2 px-3 cursor-pointer flex align-items-center justify-content-between ${org.id === selectedOption?.id
                                ? 'bg-primary text-white'
                                : 'hover:surface-hover'
                                }`}
                            onClick={() => handleOrgMenuClick({ org: org })}
                            style={{
                                borderBottom: '1px solid var(--surface-border)',
                                transition: 'all 0.2s ease-in-out',
                                minHeight: '40px'
                            }}
                        >
                            <div className="flex align-items-center gap-2">
                                <i className={`pi ${org.id === selectedOption?.id ? 'pi-check-circle' : 'pi-circle'} text-sm`} />
                                <span className="font-medium text-sm">{org.name}</span>
                            </div>
                        </div>
                    ))}
                    {filteredOrgs.length === 0 && (
                        <div className="text-center p-4 text-500 flex flex-column align-items-center gap-2">
                            <i className="pi pi-search text-xl mb-2" />
                            <span className="font-medium">No organizations found</span>
                            <span className="text-sm">Try a different search term</span>
                        </div>
                    )}
                </div>
                <div className="flex justify-content-between align-items-center mt-3">
                    <Button
                        label="Add Organization"
                        icon="pi pi-plus"
                        severity="primary"
                        size="small"
                        onClick={() => {
                            setIsAddOrg(true);
                            setShowOrgSwitcher(false);
                        }}
                    />
                </div>
            </MainModel>

            <Menu model={profileMenuItems} popup ref={profileMenu} />
            <Notifications notificationRef={notificatinRef} />
            <h3 className="font-medium">{activeRoute?.name || ''}</h3>
            <div className="flex align-items-center gap-3">
                <Button
                    className="mr-2 py-2 px-3"
                    severity="primary"
                    onClick={() => setIsAddOrg(true)}>Add Organization
                </Button>
                <Button
                    outlined
                    label={selectedOption?.name || 'Organization'}
                    icon="pi pi-chevron-down"
                    iconPos="right"
                    className="mr-2 py-2 px-3"
                    onClick={() => setShowOrgSwitcher(true)}
                    aria-controls="popup_menu_right"
                    aria-haspopup />
                <i
                    className="pi pi-sun cursor-pointer"
                    onClick={() => setIsLightTheme((prev) => !prev)}
                />
                <i
                    className="pi pi-bell p-overlay-badge mr-3 cursor-pointer"
                    onClick={(e) => notificatinRef?.current?.toggle(e)}
                >
                    <Badge
                        value={useSelector(state => state.toast.notifications.filter(n => !n.read).length)}
                        className="max-h-1rem min-w-max w-1rem line-height-3"
                        severity="danger"
                    />
                </i>
                <div
                    className="flex align-items-center cursor-pointer user-name"
                    onClick={(event) => profileMenu.current.toggle(event)}
                >
                    <Avatar
                        image={user?.profile_pic}
                        label={(user?.username && user.username[0]) || ''}
                        icon="pi pi-user"
                        className="p-1 mr-2"
                        size="large"
                        shape="circle"
                    />
                    <div>
                        <p className="name m-0 p-0 capitalize">
                            {user?.username || "My Profile"}
                        </p>
                        <small className="text-gray-500">{userRole.name || ''}</small>
                    </div>
                    <i className="pi pi-chevron-down ml-3 text-sm text-gray-500" />
                </div>
                <i
                    className="pi pi-bars hamburger-icon"
                    onClick={() => setMobileMenu(true)}
                />
            </div>
        </div>
    );
}
